/**
 * @typedef {import('../interfaces/context/IPersonasImplicadas.context.interface').IPersonasImplicadasContext} IPersonasImplicadasContext
 * @typedef {import('../interfaces/models/IPersonaImplicada.interface').IPersonaImplicada} IPersonaImplicada
 */

import React, { createContext, useContext, useEffect, useState } from 'react';
import { node } from 'prop-types';
import ModalPersonasImplicadas from '../components/ModalPersonasImplicadas';

/**
 * @type {IPersonasImplicadasContext}
 */
const contextDefaultValue = {
  personaImplicada: null,
  openModal: null,
  onEdit: null,
  onVer: null,
};

const PersonasImplicadasContext = createContext(contextDefaultValue);

/**
 * Componente que genera el Layout
 *
 * @component
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.ReactElement}
 */
const PersonasImplicadasProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const [ver, setVer] = useState(false);
  const [editData, setEditData] = useState(null);
  const [personaImplicada, setPersonaImplicada] = useState(null);

  /**
   *
   * @param {IPersonaImplicada} data
   */
  const onEditData = (data) => {
    setEditData(data);
    setShow(true);
    setVer(false);
  };

  const onClose = () => {
    setEditData(null);
    setVer(false);
    setShow(false);
  };

  /**
   *
   * @param {IPersonaImplicada} data
   */
  const onAccept = (data) => {
    setPersonaImplicada(data);
    onClose();
  };

  const openModal = () => {
    setShow(true);
  };

  useEffect(() => {
    if (!show) {
      setPersonaImplicada(null);
    }
  }, [show]);

  const value = {
    personaImplicada,
    openModal,
    onEdit: (data) => onEditData(data),
    onVer: () => setVer(true),
  };

  return (
    <PersonasImplicadasContext.Provider value={value}>
      <ModalPersonasImplicadas show={show} editData={editData} onAccept={onAccept} onClose={onClose} isVerData={ver} />
      {children}
    </PersonasImplicadasContext.Provider>
  );
};

PersonasImplicadasProvider.propTypes = {
  children: node.isRequired,
};

const usePersonasImplicadas = () => {
  const context = useContext(PersonasImplicadasContext);

  if (context === undefined) {
    throw new Error('usePersonasImplicadas must be used within provider');
  }

  return context;
};

export { PersonasImplicadasProvider, PersonasImplicadasContext, usePersonasImplicadas };
